
/*
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class VisExpandModeAPI
 * @hideconstructor
 * @classdesc API class that is used to get content for focus mode
 */
define([], () => {
	class VisExpandModeAPI {

		/**
		 * @function VisExpandModeAPI#renderExpandedModeContent
		 * @description get the expand mode content for a given container
		 * @param {DomNode} containerNode - the container node
		 */
		renderExpandedModeContent() {}

		/**
		 * @function VisExpandModeAPI#restore
		 * @description restore to pre-expanded mode
		 */
		restore(){}
	}

	return VisExpandModeAPI;
});
